<template>
  <div style="width: 100%">
    <v-row>
      <v-col>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-toolbar flat>
                <v-toolbar-title>
                  <h2 class="title primary--text text--darken-1 text-no-wrap mt-0">
                    GRÁFICOS
                  </h2>
                </v-toolbar-title>
              </v-toolbar>
            </v-row>
            <v-row class="justify-center">
              <v-col>
                <bar-chart
                  :categorias="graficos.categorias"
                  :dados="graficos.dados"
                  :fonte="`Fonte: Sistema Desenvolva, ${anoDiagnostico}`"
                  :titulo="tituloGrafico"
                  class="chart"
                  descricao-eixo-y="Notas"
                  :is-get-svg="isGetSvg"
                  @svg="(value) => svg = value"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-data-table
                  :headers="headers"
                  :items="desempenho.resultadosComportamentais"
                  :search="opcoes.pesquisa"
                  :sort-by="opcoes.ordenarPor"
                  :sort-desc="opcoes.decrescente"
                  class="elevation-0"
                  disable-pagination
                  hide-default-footer
                  show-expand
                  single-expand
                >
                  <template v-slot:top>
                    <v-row>
                      <v-toolbar flat>
                        <v-toolbar-title>
                          <h2
                            class="
                              title
                              primary--text
                              text--darken-1 text-no-wrap
                            "
                          >
                            RESULTADOS
                          </h2>
                        </v-toolbar-title>
                      </v-toolbar>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <app-sort v-model="opcoes" />
                      </v-col>
                      <v-col
                        cols="0"
                        md="4"
                      />
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <app-search v-model="opcoes" />
                      </v-col>
                    </v-row>
                  </template>
                  <template
                    v-slot:[`item.data-table-expand`]="{
                      item,
                      expand,
                      isExpanded,
                    }"
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          height="100%"
                          text
                          width="100%"
                          @click="expand(!isExpanded)"
                          v-on="on"
                        >
                          <v-badge right>
                            <template v-slot:badge>
                              <span>{{ item.itensResultado.length }}</span>
                            </template>
                            <v-icon
                              color="grey lighten-0"
                              large
                            >
                              thumb_up
                            </v-icon>
                          </v-badge>
                        </v-btn>
                      </template>
                      <span>Clique para exibir os comportamentos</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="justify-center">
                      <v-row dense>
                        <v-spacer />
                        <v-col>
                          <v-row class="justify-center">
                            <h2 class="title primary--text text--darken-1 text-no-wrap">
                              COMPORTAMENTOS
                            </h2>
                          </v-row>
                        </v-col>
                        <v-spacer />
                      </v-row>
                      <v-row>
                        <v-spacer />
                        <v-col cols="10">
                          <v-simple-table class="elevation-0 mb-4">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">COMPORTAMENTO</th>
                                  <th class="text-center">IMPORTÂNCIA</th>
                                  <th class="text-center">{{ titulo }}</th>
                                  <th class="text-center">NOTA MÁXIMA</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="itemResultado in item.itensResultado"
                                  :key="'item' + itemResultado.id"
                                >
                                  <td width="55%">
                                    <span class="grey--text text--darken-2">
                                      {{ itemResultado.comportamento.descricao }}
                                    </span>
                                  </td>
                                  <td class="text-center" width="15%">
                                    <span class="grey--text text--darken-2">
                                      {{ itemResultado.comportamento.importancia | decimal }}
                                    </span>
                                  </td>
                                  <td class="text-center" width="15%">
                                    <span class="grey--text text--darken-2">
                                      {{ itemResultado[notaProp] | decimal }}
                                    </span>
                                  </td>
                                  <td class="text-center" width="15%">
                                    <span class="grey--text text--darken-2">
                                      {{ itemResultado.notaMaxima | decimal }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-col>
                        <v-spacer />
                      </v-row>
                    </td>
                  </template>
                  <template v-slot:[`item.nota`]="{ item }">{{ item[notaProp] | decimal }}</template>
                  <template v-slot:[`item.notaMaxima`]="{ item }">{{ item.notaMaxima | decimal }}</template>
                  <template v-slot:[`body.append`]>
                    <tr>
                      <td align="center" colspan="2">
                        <strong class="subtitle-2 grey--text text--darken-2">TOTAL</strong>
                      </td>
                      <td align="center">
                        <strong>{{ desempenho[notaProp] | decimal }}</strong>
                      </td>
                      <td align="center">
                        <strong>{{ desempenho.notaMaxima | decimal }}</strong>
                      </td>
                    </tr>
                    <v-divider />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="justify-end mb-1">
          <v-tooltip
            max-width="400"
            top
          >
            <template v-slot:activator="{ on }">
              <v-btn
                class="mr-2"
                color="success"
                @click="getRelatorio(desempenho)"
                v-on="on"
              >
                <v-icon>get_app</v-icon>
                BAIXAR PDF
              </v-btn>
            </template>
            <span>Clique para baixar o relatório dos dados em formato PDF.</span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import BarChart from '@/components/chart/BarChart';
import { generatePDF, preparePdf, convertSvg } from '@/modules/relatorioPDF';
import Data from '@/modules/data';
import toDecimal from '@/filters/decimal';

export default {
  name: 'ResultadoAvaliacaoComportamental',

  components: { AppSort, AppSearch, BarChart },

  props: {
    desempenho: {
      type: Object,
      default() {
        return {};
      },
      required: true,
    },
    tipo: {
      type: String,
      default: 'AUTOAVALIACAO',
      required: true,
    },
  },

  data() {
    return {
      titulo: '',
      tituloGrafico: '',
      notaProp: '',
      notaPropDescricao: '',
      headers: [
        { text: 'COMPETÊNCIA', value: 'competencia.nome', sortable: false },
        {
          text: 'COMPORTAMENTOS',
          value: 'data-table-expand',
          width: '10%',
          align: 'center',
        },
        {
          text: 'NOTA MÁXIMA',
          value: 'notaMaxima',
          sortable: false,
          align: 'center',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'competencia.nome',
        selecionado: { id: 'competencia.nome', descricao: 'Nome da Competência' },
        lista: [
          { id: 'competencia.nome', descricao: 'Nome da Competência' },
          { id: 'itensResultado.length', descricao: 'Número de Comportamentos' },
          { id: 'notaMaxima', descricao: 'Nota Máxima' },
        ],
      },
      isGetSvg: false,
      svg: null,
    };
  },

  computed: {
    graficos() {
      switch (this.tipo) {
        case 'AUTOAVALIACAO':
          return this.$store.state.desempenho.graficosComportamentais.bar.autoavaliacao;
        case 'SUBORDINADOS':
          return this.$store.state.desempenho.graficosComportamentais.bar.subordinados;
        case 'PARES':
          return this.$store.state.desempenho.graficosComportamentais.bar.pares;
        case 'GESTOR':
          return this.$store.state.desempenho.graficosComportamentais.bar.gestor;
        default:
          return { categorias: [], dados: [] };
      }
    },
    anoDiagnostico() {
      return this.desempenho.diagnostico.ano ? this.desempenho.diagnostico.ano : '';
    },
  },

  created() {
    switch (this.tipo) {
      case 'AUTOAVALIACAO':
        this.titulo = 'NOTA AUTOAVALIAÇÃO';
        this.tituloGrafico = 'Desempenho da Autoavaliação Comportamental';
        this.notaProp = 'notaAutoavaliacao';
        this.notaPropDescricao = 'Nota da Autoavaliação';
        break;
      case 'SUBORDINADOS':
        this.titulo = 'NOTA EQUIPE';
        this.tituloGrafico = 'Desempenho das Avaliações Comportamentais da Equipe';
        this.notaProp = 'notaSubordinados';
        this.notaPropDescricao = 'Nota da Equipe';
        break;
      case 'PARES':
        this.titulo = 'NOTA EQUIPE';
        this.tituloGrafico = 'Desempenho das Avaliações Comportamentais da Equipe';
        this.notaProp = 'notaPares';
        this.notaPropDescricao = 'Nota da Equipe';
        break;
      case 'GESTOR':
        this.titulo = 'NOTA GESTOR';
        this.tituloGrafico = 'Desempenho da Avaliação Comportamental do Gestor';
        this.notaProp = 'notaGestor';
        this.notaPropDescricao = 'Nota do Gestor';
        break;
      default:
        break;
    }

    this.opcoes.lista.splice(2, 0, { id: this.notaProp, descricao: this.notaPropDescricao });
    this.headers.splice(2, 0, {
      text: this.titulo,
      value: 'nota',
      sortable: false,
      align: 'center',
    });
  },

  methods: {
    async getRelatorio(desempenho) {
      this.isGetSvg = true;
      await preparePdf(async () => {
        const inicio = Data.format(desempenho.diagnostico.inicioComportamental);
        const fim = Data.format(desempenho.diagnostico.fimComportamental);
        const colunas = ['COMPETÊNCIA', this.titulo, 'NOTA MÁXIMA'];
        const linhas = desempenho.resultadosComportamentais.map((r) => [
          r.competencia.nome,
          toDecimal(r[this.notaProp]),
          toDecimal(r.notaMaxima),
        ]);
        const rodape = ['TOTAL', toDecimal(desempenho[this.notaProp]), toDecimal(desempenho.notaMaxima)];

        const documento = {
          nome: `relatorio-desempenho-comportamental-${this.tipo.toLowerCase()}-${desempenho.diagnostico.id}`,
          cabecalho: {
            titulo: this.tituloGrafico,
            itens: [
              `Diagnóstico: ${desempenho.diagnostico.nome}`,
              `Período de Avaliação: ${inicio} a ${fim}`,
              `Usuário(a): ${desempenho.usuario.nome}`,
              `Unidade: ${desempenho.unidade.nome} (${desempenho.unidade.sigla})`,
            ],
          },
          blocos: [
            {
              titulo: 'GRÁFICOS',
              itens: [
                { tipo: 'imagem', valor: await convertSvg(this.svg), largura: 160 },
              ],
            },
            {
              titulo: 'RESULTADOS',
              itens: [{
                tipo: 'tabela',
                valor: { colunas, linhas, rodape },
              }],
            },
          ],
        };
        generatePDF(documento);
      });
      this.isGetSvg = false;
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  max-height: 400px;
  font-family: Roboto, sans-serif;
}
</style>
